// extracted by mini-css-extract-plugin
module.exports = {"button":"BaseButton_button_2Jv2Z","active":"BaseButton_active_1Bbe6"};